import { render, staticRenderFns } from "./TasahelUnderReports.vue?vue&type=template&id=ef10ce28&scoped=true&"
import script from "./TasahelUnderReports.vue?vue&type=script&lang=js&"
export * from "./TasahelUnderReports.vue?vue&type=script&lang=js&"
import style0 from "./TasahelUnderReports.vue?vue&type=style&index=0&id=ef10ce28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef10ce28",
  null
  
)

export default component.exports